import { render } from "./DisableServices.vue?vue&type=template&id=1c023432"
import script from "./DisableServices.vue?vue&type=script&lang=js"
export * from "./DisableServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__